var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemResultados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 208,
    viewBox: "0 0 312 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 208,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_591178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.3 173.028C181.6 173.028 203.73 171.515 203.73 169.648C203.73 167.781 181.6 166.268 154.3 166.268C127.001 166.268 104.87 167.781 104.87 169.648C104.87 171.515 127.001 173.028 154.3 173.028Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.18 170.978C225.24 171.058 225.28 171.138 225.28 171.218C225.28 172.948 211.34 174.348 194.15 174.348C176.96 174.348 163.02 172.948 163.02 171.218C163.02 169.908 170.99 168.788 182.3 168.328C182.24 168.248 182.2 168.168 182.2 168.088C182.2 166.358 196.14 164.958 213.33 164.958C230.52 164.958 244.46 166.358 244.46 168.088C244.46 169.398 236.49 170.518 225.18 170.978Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42 72.908L173.12 70.088C173.48 68.788 182.24 38.248 217.54 33.458L218.98 44.038C190.6 47.888 183.49 72.658 183.42 72.908V72.908Z",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41 69.668C176.75 68.498 185.07 40.978 218.63 36.668",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8 155.058V156.348C129.8 157.288 129.96 158.228 130.27 159.118L133.1 167.178C133.62 168.658 135.02 169.648 136.58 169.648H195.04C196.61 169.648 198 168.658 198.52 167.178L201.35 159.118C201.66 158.228 201.82 157.288 201.82 156.348V155.058C201.82 154.378 201.27 153.818 200.58 153.818H131.04C130.36 153.818 129.8 154.368 129.8 155.058Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62 98.1582H177.27V153.828H199.62V98.1582Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83 78.5581C174.9 74.9181 171.08 72.5181 166.79 72.5181H143.51C139.66 72.5181 136.18 74.4081 134.04 77.3781H116.49V89.9981H130.4L130.14 91.2581C129.92 92.3481 129.81 93.4481 129.81 94.5581V96.4781C129.81 97.3981 130.56 98.1481 131.49 98.1481H164.1L177.03 78.5581H176.83ZM154.68 83.9781C154.68 86.2781 152.82 88.1381 150.53 88.1381H129.87C127.58 88.1381 125.72 86.2781 125.72 83.9781V82.7081C125.72 80.4181 127.58 78.5581 129.87 78.5581H150.53C152.82 78.5581 154.68 80.4181 154.68 82.7081V83.9781Z",
    fill: "#5731FF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85 86.0081V96.4781C201.85 97.3981 201.1 98.1481 200.17 98.1481H164.1L177.03 78.5581H199.38L200.16 79.8681C201.27 81.7281 201.85 83.8481 201.85 86.0081Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75 74.478H167.78V78.558H188.75V74.478Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05 68.498H170.49V74.478H186.05V68.498Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.45 155.058V156.348C107.45 157.288 107.61 158.228 107.92 159.118L110.75 167.178C111.27 168.658 112.67 169.648 114.23 169.648H172.69C174.26 169.648 175.65 168.658 176.17 167.178L179 159.118C179.31 158.228 179.47 157.288 179.47 156.348V155.058C179.47 154.378 178.92 153.818 178.23 153.818H108.69C108.01 153.818 107.45 154.368 107.45 155.058Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.82 98.1578C178.75 98.1578 179.5 97.4078 179.5 96.4778V86.0078C179.5 83.8478 178.92 81.7278 177.81 79.8678L177.03 78.5578H159.83L157.75 82.7078H155.81L155.59 81.6178C154.51 76.3278 149.85 72.5278 144.44 72.5278H121.16C115.61 72.5278 110.83 76.4278 109.72 81.8578L107.79 91.2578C107.57 92.3478 107.45 93.4578 107.45 94.5678V96.4778C107.45 97.4078 108.2 98.1578 109.13 98.1578H177.82ZM117.28 82.7178C117.28 80.4278 119.14 78.5678 121.43 78.5678H144.17C146.46 78.5678 148.32 80.4278 148.32 82.7178V83.9878C148.32 86.2778 146.46 88.1378 144.17 88.1378H121.43C119.14 88.1378 117.28 86.2778 117.28 83.9878V82.7178Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.26 98.1582H109.68V153.828H177.26V98.1582Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9 111.018H130.89V141.008H154.9V111.018Z",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 129.198C148.62 123.558 142.92 117.638 142.89 117.608C142.86 117.638 137.07 123.658 137.2 129.328C137.2 132.148 139.75 134.438 142.9 134.438C146.05 134.438 148.6 132.148 148.6 129.328C148.6 129.288 148.6 129.238 148.6 129.198H148.58Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9 111.018L160.68 105.238",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89 111.018L125.11 105.238",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.9 141.008L160.68 146.788",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89 141.008L125.11 146.788",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.041 115.348V139.558L161.841 144.358",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44 143.408H131.79L128.21 146.998",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.72 133.318V112.248L125.11 108.638",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19 108.358H153.66L157.04 104.978",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.07 43.968C218.49 44.018 217.94 43.838 217.43 43.488C216.29 42.698 215.41 40.988 215.24 38.968C215.07 36.938 215.66 35.098 216.66 34.138C217.1 33.698 217.62 33.448 218.19 33.388C220.06 33.238 221.78 35.468 222.02 38.398C222.27 41.318 220.94 43.798 219.07 43.968Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.43 43.4882C216.29 42.6982 215.41 40.9882 215.24 38.9682C215.07 36.9382 215.66 35.0982 216.66 34.1382C217.91 34.7882 218.89 36.5282 219.07 38.6482C219.25 40.7782 218.56 42.6682 217.43 43.4882Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.99 47.1281C227.09 48.5381 228.55 50.8881 229.08 53.9481C229.33 55.3881 230.8 56.2581 232.14 55.6881L232.25 55.6381C233.44 55.1381 234.01 53.7681 233.49 52.5881C232.56 50.5081 230.61 47.5181 226.72 46.1481C226.12 45.9381 225.6 46.6281 225.99 47.1281Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.95 43.8682C226.24 43.6482 228.25 43.5182 230.41 44.2382C231.42 44.5782 232.49 43.9282 232.59 42.8682V42.7782C232.69 41.8382 232 40.9982 231.06 40.9282C229.4 40.8082 226.8 41.0382 224.57 43.0682C224.23 43.3782 224.49 43.9582 224.95 43.8782V43.8682Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62 110.618V98.1582H177.27V123.178C185.52 111.198 196.26 110.508 199.62 110.618Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 130.068V137.218C183.46 128.228 191.32 122.268 194.94 121.158C195.59 120.958 196.05 120.388 196.05 119.718V119.648C196.05 118.738 195.24 118.028 194.34 118.168C190.51 118.768 183.14 121.548 177.27 130.068Z",
    fill: "#5731FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94 161.738H169.01",
    stroke: "#5731FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.96 108.938C121.992 108.938 137.42 93.5098 137.42 74.4781C137.42 55.4463 121.992 40.0181 102.96 40.0181C83.9283 40.0181 68.5 55.4463 68.5 74.4781C68.5 93.5098 83.9283 108.938 102.96 108.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.96 108.938C121.992 108.938 137.42 93.5098 137.42 74.4781C137.42 55.4463 121.992 40.0181 102.96 40.0181C83.9283 40.0181 68.5 55.4463 68.5 74.4781C68.5 93.5098 83.9283 108.938 102.96 108.938Z",
    stroke: "#5731FF",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89 87.8782L113.65 80.6382C113.29 80.2782 113.24 79.7082 113.52 79.2782C115.32 76.4382 116.17 72.9382 115.57 69.2082C114.57 62.9582 109.42 58.0082 103.14 57.2282C93.7102 56.0682 85.7802 64.0082 86.9702 73.4482C87.7502 79.6682 92.6402 84.7782 98.8202 85.8182C102.48 86.4282 105.94 85.6582 108.76 83.9482C109.19 83.6882 109.75 83.7282 110.1 84.0882L117.38 91.3682C118.01 91.9982 119.04 91.9982 119.67 91.3682L120.86 90.1782C121.49 89.5482 121.49 88.5182 120.86 87.8882L120.89 87.8782ZM91.7902 71.5682C91.7902 66.3082 96.0502 62.0482 101.31 62.0482C106.57 62.0482 110.83 66.3082 110.83 71.5682C110.83 76.8282 106.57 81.0882 101.31 81.0882C96.0502 81.0882 91.7902 76.8282 91.7902 71.5682Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.19 67.6182L97.4399 75.3682",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4399 67.6182L105.19 75.3682",
    stroke: "#5731FF",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_591178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176.46,
    height: 141.46,
    fill: "white",
    transform: "translate(68 32.8882)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemResultados);
export default __webpack_public_path__ + "static/media/sem-resultados.019f1d9c.svg";
export { ForwardRef as ReactComponent };